<template>
  <fts-design-modal
    width="992px"
    append-header-class="tour-modal__header"
    append-content-class="tour-modal__body"
    append-footer-class="tour-modal__footer"
    class="fts-tour-modal"
    ref="ftsTourModal"
    @closed="reset"
  >
    <!-- header -->
    <template #header>
      <fts-btn lg text icon @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <!-- header -->
      <div class="design-modal-content__header">
        <div class="design-modal-content__header-title">
          Welcome to Inistate
        </div>
        <div class="design-modal-content__header-description">
          Unleash the potential of your organization now
        </div>
      </div>
      <!-- video -->
      <div class="tour-video">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/z265D4oDpqg?rel=0"
          title="YouTube video player"
          frameborder="0"
          allowfullscreen
          class="tour-video-player"
          ref="tourEmbedVideo"
        />
        <div class="tour-video-link">
          <a
            href="https://www.youtube.com/watch?v=z265D4oDpqg"
            target="_blank"
            class="fts-link-default"
          >
            show video in another window
          </a>
        </div>
        <!-- <video 
          :controls="isStart" 
          disablePictureInPicture
          controlslist="nodownload" 
          class="tour-video-player" 
          ref="tourVideoPlayer"
        >
          <source src="../../../assets/video/studio-tour.mp4" type="video/mp4">
          video not supported
        </video> -->

        <!-- <div class="tour-video-overlay" v-if="!isStart">
          <div class="tour-video-start" @click="playVideo">
            <font-awesome-icon :icon="['fas', 'play']" />
          </div>
        </div> -->
      </div>
      <!-- banner -->
      <div class="tour-banner-container">
        <div class="tour-banner-wrapper">
          <div class="tour-banner__header">
            <font-awesome-icon :icon="['fab', 'twitter']" class="tour-banner__header-icon" />
          </div>
          <div class="tour-banner-title">
            Follow us on twitter
          </div>
          <div class="tour-banner-description">
            Get latest news and features on Inistate
          </div>
          <div class="tour-banner-action">
            <a :href="twitterURL" target="_blank" class="fts-link-primary">
              @inistatehq
            </a>
          </div>
        </div>

        <div class="tour-banner-wrapper">
          <div class="tour-banner__header tour-banner-mobile-store">
            <a class="tour-banner-mobile-store-img" :href="iOSAppStoreURL" target="_blank">
              <img src="../../../assets/images/brand/app-store-black.svg" />
            </a>
            <a class="tour-banner-mobile-store-img" :href="androindPlayStoreURL" target="_blank">
              <img src="../../../assets/images/brand/google-play-badge.svg" />
            </a>
          </div>
          <div class="tour-banner-title">
            Use on mobile or tablet
          </div>
          <div class="tour-banner-description">
            Follow our journey in perfecting no-code system app builder on our blog.
          </div>
          <div class="tour-banner-action">
            <a :href="blogURL" target="blank" class="fts-link-primary">
              Inistate Blog
            </a>
          </div>
        </div>

        <div class="tour-banner-wrapper">
          <div class="tour-banner__header">
            <font-awesome-icon :icon="['fab', 'discord']" class="tour-banner__header-icon" />
          </div>
          <div class="tour-banner-title">
            Join us on Discord
          </div>
          <div class="tour-banner-description">
            Join here to get support if you facing problems.
          </div>
          <div class="tour-banner-action">
            <a :href="discordURL" target="_blank" class="fts-link-primary">
              Inistate Discord Community
            </a>
          </div>
        </div>
      </div>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn lg text text-transform-init @click="close">
        Skip
      </fts-btn>
      <!-- done -->
      <fts-btn lg text-transform-init box-shadow-none color="secondary" @click="done">
        Get started
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import commons from '../../commons/commons';

import FTSDesignModal from "../../design/FTSDesignModal";
import FTSBtn from "../FTSBtn";
import FTSMoji from "../FTSMoji";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
  },
  data: () => ({
    iOSAppStoreURL: commons.iOSAppStoreURL,
    androindPlayStoreURL: commons.androindPlayStoreURL,
    twitterURL: commons.twitterURL,
    discordURL: commons.discordURL,
    blogURL: commons.blogURL,
    resolve: null,
    isStart: false,
  }),
  methods: {
    async show() {
      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsTourModal.show();
      })
    },
    done() {
      this.resolve && this.resolve(true);
      this.close();
    },
    close() {
      this.$refs.ftsTourModal.close();
    },
    reset() {
      this.resolve && this.resolve();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    playVideo() {
      this.isStart = true;
      this.$refs.tourVideoPlayer.play();
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-tour-modal {
  .tour-modal__header {
    justify-content: flex-end;
    padding: .75rem;
  }
  .tour-modal__body {
    padding: 0 1.5rem 1.5rem;
    .design-modal-content__header {
      margin-bottom: 1rem;
    }
  }
  .tour-modal__footer {
    padding-bottom: 1.5rem;
    background-color: var(--fts-background);
  }
  /* video */
  .tour-video {
    position: relative;
    max-width: 36rem;
    margin-bottom: 2.5rem;
    margin-left: auto;
    margin-right: auto;
    .tour-video-player {
      width: 100%;
    }
    .tour-video-link {
      margin-top: 1rem;
      font-size: .875rem;
      text-align: center;
    }
    // .tour-video-overlay {
    //   @include flex-center-middle;
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    //   background: rgba($color: #000, $alpha: .15);
    //   .tour-video-start {   
    //     padding: 1.5rem 3rem;
    //     border-radius: 1.5rem;
    //     background-color: var(--fts-ternary-blue);
    //     box-shadow: var(--fts-elevation-2);
    //     font-size: 2rem;
    //     color: #fff;
    //     cursor: pointer;
    //     transition: transform .3s linear;
    //     &:hover {
    //       transform: scale(1.125);
    //     }
    //   }
    // }
  }
  /* banner */
  .tour-banner-container {
    display: grid;
    gap: 1rem;
    border-radius: .5rem;
    background-color: var(--fts-primary-light);
    background-size: cover;
    background-image: url("../../../assets/images/studio/mesh-gradient.png");
    .tour-banner-wrapper {
      padding: 1.5rem;
      text-align: center;
    }
    .tour-banner__header {
      @include flex-center-middle;
      height: 5rem;
      .tour-banner__header-icon {
        font-size: 2.5rem;
        color: var(--fts-primary);
      }
    }
    .tour-banner-mobile-store {
      .tour-banner-mobile-store-img {
        height: 2.5rem;
        display: inline-flex;
        &:not(:first-child) {
          margin-left: .5rem; 
        }
      }
    }
    .tour-banner-title {
      margin-top: 1rem;
      font-weight: 700;
      font-size: 1.25rem;
      line-height: 1.75rem;
      color: var(--fts-primary);
    }
    .tour-banner-description {
      margin-top: .5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .tour-banner-action {
      margin-top: 1rem;
    }
  }
  /* to-do utilities.scss */
  @media (min-width: 768px) {
    .tour-banner-container {
      grid-template-columns: repeat(2,minmax(0,1fr));
    }
  }
  @media (min-width: 1024px) {
    .tour-banner-container {
      grid-template-columns: repeat(3,minmax(0,1fr));
    }
  }
}
</style>